import { Box, Heading } from 'grommet'
import styled from 'styled-components'

import { NormalizedWrapper } from '@theme'
import { Link } from '@ui/links/Link'

export const RatingsSection = styled(Box)`
  margin: ${({ theme }) => theme.spaces[5]}px auto;
`

export const Content = styled(NormalizedWrapper)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1100px;

  ${({ theme }) => theme.below.tablet`
    width: auto;
  `}
`

export const WrapperImage = styled.span`
  height: 165px;
  position: relative;

  ${({ theme }) => theme.below.tablet`
    margin-bottom: ${theme.spaces[3]}px;
    padding: ${theme.spaces[3]}px;
    height: 170px;
  `}
  img {
    object-fit: contain;
  }
`

export const RatingLink = styled(Link)`
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  filter: grayscale(1);
  flex-direction: column;
  height: 165px;
  margin: 0 auto;
  order: ${({ order }) => order};
  transition: all 0.3s ease;
  width: 165px;

  ${({ theme }) => theme.above.mobileL`
    margin: ${theme.spaces[3] + 4}px;
  `}

  ${({ theme }) => theme.below.tablet`
    margin-bottom: ${theme.spaces[3]}px;
    padding: ${theme.spaces[3]}px;
    height: 170px;
    width: 170px;
  `}
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    filter: grayscale(0);
    text-decoration: none;

    h3 {
      text-decoration: underline;
    }
  }
`

export const SubTitle = styled(Heading)`
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: ${({ theme }) => theme.fontWeight[6]};
  line-height: ${({ theme }) => theme.lineHeight[4]}px;
  margin-top: ${({ theme }) => theme.spaces[2]}px;
  text-align: center;
`
